var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgFeeder = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 33,
    viewBox: "0 0 28 33",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 21L21 16.333 21 0 7 0 7 16.333zM22.773 19.367L19.857 21.303 23.333 32.667 26.833 32.667zM5.203 19.343L1.167 32.667 4.667 32.667 8.167 21.327z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFeeder, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/feeder.86ece9e9.svg";
export { ForwardRef as ReactComponent };